import { FormControl, Grid, InputLabel, Select, TextField, Typography, Box } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDatoPersonaNatural, setEstadosCiviles, setPersonaNatural, setSexos
    , setTiposPersona, setOcupaciones, setLugaresTrabajo, setValidations, initPerson, defaultPersonaNatural } from "../../redux/person/personSlice";
import UbigeoSearch from './../UbigeoSearch';
import UbigeoAutocomplete from '../common/UbigeoAutocomplete';
import AutocompleteRegistro from '../AutocompleteRegistro';
import { FormHelperText as HelperText } from '@mui/material';
import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";
import * as usuarioService from "../../services/usuarioService";

const PersonaNatural = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(initPerson({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
            const timer = setTimeout(() => inputRef.current?.focus(), 150);
            return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const [openUbigeoSearch, setOpenUbigeoSearch] = useState(false);
    const fechaIngresoMinimo = new Date(2010, 1, 1);
    const fechaNacimientoMaximo = new Date();

    const personaNatural = useSelector((state) => state.person[sliceKey]?.personaNatural);
    const validate = useSelector((state) => state.person[sliceKey]?.validationActive);
    const sexos = useSelector((state) => state.person[sliceKey]?.sexos);
    const estadosCiviles = useSelector((state) => state.person[sliceKey]?.estadosCiviles);
    const tiposPersona = useSelector((state) => state.person[sliceKey]?.tiposPersona);
    const ocupaciones = useSelector((state) => state.person[sliceKey]?.ocupaciones);
    const lugaresTrabajo = useSelector((state) => state.person[sliceKey]?.lugaresTrabajo);

    var validation = {
        primerNombre: {
            error: personaNatural?.primerNombre != null && personaNatural?.primerNombre?.length < 3,
            message: "Falta ingresar el nombre",
        },
        primerApellido: {
            error: personaNatural?.primerApellido != null && personaNatural?.primerApellido?.length < 3,
            message: "Falta ingresar el apellido",
        },
        idSexo: {
            error: personaNatural?.idSexo === 0,
            message: "Falta ingresar el sexo",
        },
        idEstadoCivil: {
            error: personaNatural?.idEstadoCivil === 0,
            message: "Falta ingresar el estado civil",
        },
        idTipoPersona: {
            error: personaNatural?.idTipoPersona === 0,
            message: "Falta ingresar el tipo de persona",
        },
        fechaIngreso: {
            error: Date.parse(personaNatural?.fechaIngreso) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
        fechaNacimiento: {
            error: Date.parse(personaNatural?.fechaNacimiento) > fechaNacimientoMaximo,
            message: "Debe ser una fecha menor a hoy",
        },
    };
    const openCloseUbigeoSearch = () => { setOpenUbigeoSearch(!openUbigeoSearch); };

    const fetchPersonaNatural = async () => {
        const response = await personaService.getPersonaNatural(props.id);
        const persona = response ? { ...response } : { ...defaultPersonaNatural };

        // Al registrar una persona el ubigeo se propone con el de la filial del
        // usuario que la esta registrando. Si la persona ya tiene uno se respeta
        // el que tiene.
        if (!(persona.idUbigeoNacimiento > 0)) {
            const perfil = await usuarioService.obtenerPerfil().catch(() => null);

            if (perfil && perfil.idUbigeo > 0) {
                persona.idUbigeoNacimiento = parseInt(perfil.idUbigeo);
                persona.ubigeoNacimiento = perfil.ubigeo || "";
            }
        }

        // Se guarda todo de una sola vez: si se guardara antes la persona y despues
        // el ubigeo, una segunda carga de la pantalla podria dejar el ubigeo sin
        // guardar.
        dispatch(setPersonaNatural({ sliceKey: sliceKey, data: persona }));
    };
    const fetchSexos = async () => {
        const response = await catalogoService.getCatalogosByPadre(32);
        dispatch(setSexos({sliceKey, data: response}));
    };
    const fetchEstadosCiviles = async () => {
        const response = await catalogoService.getCatalogosByPadre(35);
        dispatch(setEstadosCiviles({sliceKey: sliceKey, data: response}));
    };
    const fetchTiposPersona = async () => {
        const response = await catalogoService.getCatalogosByPadre(22);
        dispatch(setTiposPersona({sliceKey: sliceKey, data: response}));
    };
    const fetchOcupaciones = async () => {
        const response = await catalogoService.getCatalogosByPadre(94);
        dispatch(setOcupaciones({sliceKey: sliceKey, data: response}));
    };
    const fetchLugaresTrabajo = async () => {
        const response = await personaService.getLugaresTrabajo();
        dispatch(setLugaresTrabajo({sliceKey: sliceKey, data: response}));
    };

    useEffect(() => {
        fetchPersonaNatural();
        fetchSexos();
        fetchEstadosCiviles();
        fetchTiposPersona();
        fetchOcupaciones();
        fetchLugaresTrabajo();
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, [props.id]);

    useEffect(() => {
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, [personaNatural]);

    var handleChangePersonaNatural = e => {
        dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    };
    const setSelectUbigeoSearch = (selectSearhUbigeo) => {
        dispatch(setDatoPersonaNatural({
            sliceKey: sliceKey,
            name: "idUbigeoNacimiento",
            value: selectSearhUbigeo ? parseInt(selectSearhUbigeo.idUbigeo || selectSearhUbigeo.id || 0) : 0
        }));
        dispatch(setDatoPersonaNatural({
            sliceKey: sliceKey,
            name: "ubigeoNacimiento",
            value: selectSearhUbigeo ? selectSearhUbigeo.descripcion : ""
        }));
    };
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message);
        });

        return messages;
    };
    
    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <TextField
                        required
                        name="primerNombre"
                        label="1er Nombre"
                        fullWidth
                        value={personaNatural?.primerNombre || ""}
                        onChange={handleChangePersonaNatural}
                        error={validate?.primerNombre && validation.primerNombre.error}
                        helperText={validate?.primerNombre && validation.primerNombre.error ? validation.primerNombre.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                        inputRef={inputRef}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <TextField
                        name="segundoNombre"
                        label="2do Nombre"
                        fullWidth
                        value={personaNatural?.segundoNombre || ""}
                        onChange={handleChangePersonaNatural}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <TextField
                        required
                        name="primerApellido"
                        label="1er Apellido"
                        fullWidth
                        value={personaNatural?.primerApellido || ""}
                        onChange={handleChangePersonaNatural}
                        error={validate?.primerApellido && validation.primerApellido.error}
                        helperText={validate?.primerApellido && validation.primerApellido.error ? validation.primerApellido.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <TextField
                        name="segundoApellido"
                        label="2do Apellido"
                        fullWidth
                        value={personaNatural?.segundoApellido || ""}
                        onChange={handleChangePersonaNatural}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <TextField
                        required
                        name="fechaIngreso"
                        label="Fecha Ingreso"
                        fullWidth
                        type="date"
                        value={moment(personaNatural?.fechaIngreso || moment()).format('yyyy-MM-DD')}
                        onChange={handleChangePersonaNatural}
                        error={validate?.fechaIngreso && validation.fechaIngreso.error}
                        helperText={validate?.fechaIngreso && validation.fechaIngreso.error ? validation.fechaIngreso.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}>
                        <InputLabel htmlFor="input-sexo">Sexo</InputLabel>
                        <Select
                            native
                            label="Sexo"
                            value={personaNatural?.idSexo || 0}
                            onChange={handleChangePersonaNatural}
                            inputProps={{
                                name: 'idSexo',
                                id: 'input-sexo',
                            }}
                            size="small"
                            disabled={isReadOnly}
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {sexos?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <FormControl required fullWidth error={validate?.idEstadoCivil && validation.idEstadoCivil.error}>
                        <InputLabel htmlFor="input-estadocivil">Estado Civil</InputLabel>
                        <Select
                            native
                            label="Estado Civil"
                            value={personaNatural?.idEstadoCivil || 0}
                            onChange={handleChangePersonaNatural}
                            inputProps={{
                                name: 'idEstadoCivil',
                                id: 'input-estadocivil',
                            }}
                            size="small"
                            disabled={isReadOnly}
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {estadosCiviles?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>{validate?.idEstadoCivil && validation.idEstadoCivil.error ? validation.idEstadoCivil.message : ""}</HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <FormControl required fullWidth error={validate?.idTipoPersona && validation.idTipoPersona.error}>
                        <InputLabel htmlFor="input-tipopersona">Tipo Persona</InputLabel>
                        <Select
                            native
                            label="Tipo Persona"
                            value={personaNatural?.idTipoPersona || 0}
                            fullWidth
                            onChange={handleChangePersonaNatural}
                            inputProps={{
                                name: 'idTipoPersona',
                                id: 'input-tipopersona',
                            }}
                            size="small"
                            disabled={isReadOnly}
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {tiposPersona?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>{validate?.idTipoPersona && validation.idTipoPersona.error ? validation.idTipoPersona.message : ""}</HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <TextField
                        required
                        name="fechaNacimiento"
                        label="Fecha Nac."
                        fullWidth
                        type="date"
                        value={moment(personaNatural?.fechaNacimiento || moment()).format('yyyy-MM-DD')}
                        onChange={handleChangePersonaNatural}
                        error={validate?.fechaNacimiento && validation.fechaNacimiento.error}
                        helperText={validate?.fechaNacimiento && validation.fechaNacimiento.error ? validation.fechaNacimiento.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <UbigeoAutocomplete
                        name="ubigeoNacimiento"
                        label="Lugar de Nacimiento"
                        value={personaNatural?.idUbigeoNacimiento}
                        initialLabel={personaNatural?.ubigeoNacimiento || ""}
                        disabled={isReadOnly}
                        onChange={(selected) => {
                            dispatch(setDatoPersonaNatural({
                                sliceKey: sliceKey,
                                name: "idUbigeoNacimiento",
                                value: selected ? parseInt(selected.id) : 0
                            }));
                            dispatch(setDatoPersonaNatural({
                                sliceKey: sliceKey,
                                name: "ubigeoNacimiento",
                                value: selected ? selected.descripcion : ""
                            }));
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={6} sx={{ display: props.hideInputs ? "none" : "block" }}>
                    <FormControl fullWidth>
                        <AutocompleteRegistro
                            name="idOcupacion"
                            label="Ocupación"
                            texto={personaNatural?.ocupacion || ""}
                            idSeleccionado={personaNatural?.idOcupacion || 0}
                            opciones={ocupaciones || []}
                            tipoRegistro="ocupación"
                            disabled={isReadOnly}
                            size="small"
                            onTexto={(newValue) => {
                                dispatch(setDatoPersonaNatural({ sliceKey: sliceKey, name: "ocupacion", value: newValue || "" }));
                            }}
                            onSeleccionar={(newValue) => {
                                dispatch(setDatoPersonaNatural({ sliceKey: sliceKey, name: "idOcupacion", value: newValue?.id || 0 }));
                                dispatch(setDatoPersonaNatural({ sliceKey: sliceKey, name: "ocupacion", value: newValue?.descripcion || "" }));
                            }}
                            onBuscar={async (texto) => {
                                return await catalogoService.getCatalogosByPadre(94, texto);
                            }}
                            onRegistrarNuevo={async (texto) => {
                                const nuevoId = await catalogoService.addUpdateCatalogo({
                                    idCatalogo: 0,
                                    idPadre: 94,
                                    descripcion: texto,
                                    codigo: "",
                                    estado: "A"
                                });
                                if (nuevoId > 0) {
                                    await fetchOcupaciones();
                                    return { id: nuevoId, descripcion: texto };
                                }
                                return null;
                            }}
                            puedeRegistrar={!isReadOnly}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4} lg={6} sx={{ display: props.hideInputs ? "none" : "block" }}>
                    <FormControl fullWidth>
                        <AutocompleteRegistro
                            name="idLugarTrabajo"
                            label="Lugar de Trabajo"
                            texto={personaNatural?.lugarTrabajo || ""}
                            idSeleccionado={personaNatural?.idLugarTrabajo || 0}
                            opciones={lugaresTrabajo || []}
                            tipoRegistro="lugar de trabajo"
                            disabled={isReadOnly}
                            size="small"
                            onTexto={(newValue) => {
                                dispatch(setDatoPersonaNatural({ sliceKey: sliceKey, name: "lugarTrabajo", value: newValue || "" }));
                            }}
                            onSeleccionar={(newValue) => {
                                dispatch(setDatoPersonaNatural({ sliceKey: sliceKey, name: "idLugarTrabajo", value: newValue?.id || 0 }));
                                dispatch(setDatoPersonaNatural({ sliceKey: sliceKey, name: "lugarTrabajo", value: newValue?.descripcion || "" }));
                            }}
                            onBuscar={async (texto) => {
                                return await personaService.buscarLugaresTrabajo(texto);
                            }}
                            onRegistrarNuevo={async (texto) => {
                                const nuevo = await personaService.addPersonaJuridicaRapida(texto);
                                if (nuevo && nuevo.id > 0) {
                                    await fetchLugaresTrabajo();
                                    return { id: nuevo.id, descripcion: nuevo.descripcion || texto };
                                }
                                return null;
                            }}
                            puedeRegistrar={!isReadOnly}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <UbigeoSearch open={openUbigeoSearch} openClose={openCloseUbigeoSearch} setSelection={setSelectUbigeoSearch} />
        </Grid>
    );
};
export default PersonaNatural;
